(function (t) {
// fr
t.add("header.connecting", "Connexion en cours", "HWIOAuthBundle", "fr");
t.add("header.success", "Connexion r\u00e9ussie avec le compte '%name%' !", "HWIOAuthBundle", "fr");
t.add("header.register", "S'inscrire avec le compte '%name%'", "HWIOAuthBundle", "fr");
t.add("header.registration_success", "Enregistrement et connexion du compte '%username%' r\u00e9ussis !", "HWIOAuthBundle", "fr");
t.add("connect.confirm.cancel", "Annuler", "HWIOAuthBundle", "fr");
t.add("connect.confirm.submit", "Connecter le compte", "HWIOAuthBundle", "fr");
t.add("connect.confirm.text", "\u00cates-vous s\u00fbr de vouloir connecter votre compte %service% avec votre compte '%name%' ?", "HWIOAuthBundle", "fr");
t.add("connect.registration.cancel", "Annuler", "HWIOAuthBundle", "fr");
t.add("connect.registration.submit", "Enregistrer le compte", "HWIOAuthBundle", "fr");
})(Translator);
